module.exports = __webpack_public_path__ + "images/prev_logo-b89059791c38a26465ebd024831f7ee9.png";